<template>
  <div class="social-view-component">
    <template v-if="hasData">
      <page-header :breadcrumbs="breadcrumbs">
        <template #topbar>
          <h1>{{ widgetConfig.name || 'Community' }}</h1>
        </template>
      </page-header>
      <div class="social-view-content">
        <img
          class="content-attachment"
          :src="socialAttachment"
          alt="A map of active users across the USA"
        />
        <p class="content-title">
          {{ contentTitle }}
        </p>
        <p class="content-description">
          {{ contentDescription }}
        </p>
        <div class="content-data">
          <div class="content-data-row">
            <p class="row-label">
              Members Studying Now
            </p>
            <p class="row-data">
              {{ formatSocialData(totalActiveUsersNow) }}
            </p>
          </div>
          <div class="content-data-row">
            <p class="row-label">
              Total Number of Members
            </p>
            <p class="row-data">
              {{ formatSocialData(totalActiveUsers) }}
            </p>
          </div>
          <div class="content-data-row">
            <p class="row-label">
              Total Questions Answered
            </p>
            <p class="row-data">
              {{ formatSocialData(totalAnswers) }}
            </p>
          </div>
          <div class="content-data-row">
            <p class="row-label">
              Questions Answered Today
            </p>
            <p class="row-data">
              {{ formatSocialData(totalAnswersToday) }}
            </p>
          </div>
        </div>
        <div class="share-container">
          <share-popover
            :context="context"
            :popover-description="shareDescription"
            :popover-title="shareTitle"
            :share-message="shareDescription"
            :share-text="shareText"
            :url="shareUrl"
          />
        </div>
      </div>
    </template>
    <loading v-else />
  </div>
</template>

<script>
import Loading from '@/components/singletons/loading';
import PageHeader from '@/components/singletons/pageHeader';
import SharePopover from '@/components/share/sharePopover';

export default {
  name: 'SocialView',
  components: { Loading, PageHeader, SharePopover },
  data() {
    return {
      hasData: false,
      totalActiveUsers: null,
      totalActiveUsersNow: null,
      totalAnswers: null,
      totalAnswersToday: null,
      widgetConfig: null,
    };
  },
  computed: {
    breadcrumbs() {
      return [{name: this.widgetConfig.name || 'Community', route: {}}];
    },
    contentDescription() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofDescription;
      }
    },
    contentTitle() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofTitle;
      }
    },
    context() {
      return 'social';
    },
    shareDescription() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofShareDescription;
      }
    },
    shareText() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofShareText.toUpperCase();
      }
    },
    shareTitle() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofShareTitle;
      }
    },
    shareUrl() {
      if (this.widgetConfig) {
        return this.widgetConfig.config?.socialProofShareUrl;
      }
    },
    socialAttachment() {
      if (this.widgetConfig) {
        const attachmentId = this.widgetConfig.config?.socialProofAttachmentId;
        const attachment = this.$store.getters['attachments/get'][attachmentId];
        return attachment?.url;
      }
    },
  },
  mounted() {
    const user = this.$store.getters['session/currentUser'];

    let dashboardWidgetId = this.$route.query?.widget;
    let widget;
    if (dashboardWidgetId) {
      widget = this.$store.getters['dashboardWidgets/widgets'][dashboardWidgetId];
    } else if (user) {
      const dashboard = this.$store.getters['dashboards/menuDefaultDashboard'];
      const dashboardWidgets = dashboard?.appDashboardsDashboardWidgets;
      if (dashboardWidgets) {
        const socialProofAppDashboardWidget = dashboardWidgets.find(dashboardWidget => {
          const widget = this.$store.getters['dashboardWidgets/widgets'][dashboardWidget.dashboardWidgetId];
          return widget.widgetType === 'social_proof';
        });
        widget = this.$store.getters['dashboardWidgets/widgets'][socialProofAppDashboardWidget?.dashboardWidgetId];
      }
    }

    if (widget) {
      this.widgetConfig = widget;
      this.$store.getters['session/ajax'].get('/social_proof').then(({ data }) => {
        this.setSocialData(data);
      });
      if (widget.config?.socialProofAttachmentId) {
        this.$store.dispatch('attachments/fetch', { ids: [widget.config.socialProofAttachmentId] });
      }
    } else {
      this.$router.push({ name: 'home' });
    }
  },
  methods: {
    formatSocialData(num) {
      const numified = Number(num);
      if (isNaN(numified)) {
        return '';
      } else {
        return numified.toLocaleString();
      }
    },
    setSocialData(data) {
      this.hasData = true;
      this.totalActiveUsers = data.totalActiveUsers;
      this.totalActiveUsersNow = data.totalActiveUsers_1h;
      this.totalAnswers = data.totalQuestionsAnswered;
      this.totalAnswersToday = data.totalQuestionsAnswered_24h;
    },
  },
};
</script>

<style lang="scss" scoped>
.social-view-component {
  margin-top: rem-calc(64) !important;

  .social-view-content {
    margin: 0 auto;
    max-width: rem-calc(560);

    .content-attachment {
      width: 100%;
      margin-bottom: rem-calc(32);
    }

    .content-title {
      font-weight: $bold;
    }

    .content-data {
      margin-top: rem-calc(48);

      .content-data-row {
        border-top: 1px solid #dcdcdc;
        display: flex;
        justify-content: space-between;

        &:last-child {
          border-bottom: 1px solid #dcdcdc
        }

        .row-data {
          font-weight: $bold;
        }
      }
    }

    .share-container {
      align-items: center;
      background-color: #ffffff;
      border-radius: 4px;
      border: 1px solid #000000;
      display: flex;
      height: 64px;
      justify-content: center;
      margin-top: rem-calc(64);
      width: 100%;
    }
  }
}
</style>
